const dataServices = [
    {
        class: 'fas fa-laptop-code',
        title: 'Web Developer',
        description: 'Desarrollo de sitios web a la medida adaptables a cualquier dispositivo',        
    },
    {
        class: 'fab fa-js',
        title: 'Front-End',
        description: 'Desarrollo de sitios web del lado del cliente utilizando las librerias React.js, Angular.js y Vue.js',        
    },
    {
        class: "fas fa-mobile-alt",
        title: 'Mobile application development',
        description: 'Creacion de App para android utilizando React Native.',        
    },
    {
        class: 'fab fa-node',
        title: 'Backend',
        description: 'Implementacion de API REST con Node.js, Express.js, Cors y Axios.',        
    },
    {
        class: 'fas fa-database',
        title: 'Databases',
        description: 'Base de datos relacionales como SQl y MySQl, y no relacionales como Cloud Firestore y MongoDB',        
    },
    {
        class: 'fas fa-desktop',
        title: 'Desktop application development',
        description: 'Desarrollo de aplicaciones de escritorio .NET con C# en Visual Studio con MVC (modelo, vista, controlador), y aplicaciones de escritorio y web (JSP) con Java en NetBeans',        
    },
    {
        class: 'fas fa-cloud-upload-alt',
        title: 'Hosting Services',
        description: 'Servicios de hospedaje a sitios web, como lo son Firebase hosting y netlify con versionamiento de despliegues a producción.',        
    },
    {
        class: 'fas fa-shopping-cart',
        title: 'Ecommerce',
        description: 'Desarrollo de tiendas virtuales con CMS como Wordpress con herramientas tales como, WooCommerce, PrestaShop y Shopify',        
    },
    {
        class: 'fas fa-business-time',
        title: 'Agile methodologies',
        description: 'Desarrollo de proyectos de software con metodologías ágiles tales como SCRUM, XP, CRYSTAL CLEAR Y KANBAN',        
    },
    {
        class: 'fas fa-tools',
        title: 'Additional Tools',
        description: 'Ant Design, Bootstrap, Material UI, JQuery, Moment, Figma, Planner, Jira, Git hub, Visual Code, Styled Component, XAMPP, Visual Studio, WordPress, PrestaShop, Woommerce',        
    },
    
]

export const dataProgress = [
    { cant: 90, type:'lenguaje',title: "JavaScript"},
    { cant: 80, type:'lenguaje',title: "JAVA" },
    { cant: 70, type:'lenguaje',title: "C#" },
    { cant: 75, type:'lenguaje',title: "PHP" },
    { cant: 90, type:'database',title: "MYSQL" },
    { cant: 90, type:'database',title: "SQL" },
    { cant: 85, type:'database',title: "CLOUD FIRESTORE" },
    { cant: 85, type:'database',title: "MONGODB" },
    { cant: 90, type:'frame',title: "REACT JS" },
    { cant: 70, type:'frame',title: "ANGULAR JS" },
    { cant: 65, type:'frame',title: "VUE JS" },
    { cant: 80, type:'frame',title: "REACT NATIVE" },
    { cant: 70, type:'frame',title: "NODE JS" },
    { cant: 70, type:'frame',title: "EXPRESS JS" },
    { cant: 90, type:'others',title: "Bootstrap" },
    { cant: 90, type:'others',title: "Material UI" },
    { cant: 90, type:'others',title: "HTML 5" },
    { cant: 90, type:'others',title: "CSS 3" },
    { cant: 70, type:'others',title: ".NET" },
    { cant: 75, type:'others',title: "API REST" },
    { cant: 75, type:'others',title: "CORS" },
    { cant: 90, type:'others',title: "MOMENT JS" },
    { cant: 85, type:'others',title: "Jquery" },
    { cant: 90, type:'others',title: "Ant Design" },
    { cant: 70, type:'others',title: "Crystal Report" },
    { cant: 90, type:'others',title: "WordPress" },
]

export default dataServices